import styled from '@emotion/styled';
import { ButtonProps, StyledResetButton } from '~/shared/components';
import { breakpoints } from '~/theme';
import { cover } from '~/shared/utils/styled';

export const StyledOrderContainer = styled.div(({ theme }) => ({
    height: theme.spaces[5],
    position: 'relative',
    zIndex: theme.zIndices['drawer'],
}));

export const StyledOrderTrigger = styled(StyledResetButton)<{ isOpen: boolean }>(
    ({ theme, isOpen }) => ({
        display: 'none',
        height: theme.spaces[5],
        fontFamily: theme.fonts.body,
        fontSize: theme.fontSizes.sm,
        padding: `0 ${theme.spaces[2]} 2px`, // Padding Bottom 2px because of border 2px except in bottom, causes a desalignment with other items
        border: `2px solid ${isOpen ? theme.colors.dark : 'transparent'}`,
        borderBottom: `none`,
        '&:hover': {
            backgroundColor: theme.colors.light30,
        },
        [breakpoints.md]: {
            display: 'inline-flex',
        },
    })
);

export const StyledGroupTitle = styled.label(({ theme }) => ({
    marginRight: theme.spaces[2],
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes.sm,
    cursor: 'pointer',
}));

export const StyledSortList = styled.ul(({ theme }) => ({
    zIndex: theme.zIndices[1],
    position: 'absolute',
    backgroundColor: theme.colors.light,
    border: `2px solid ${theme.colors.dark}`,
    minWidth: '100%',
    whiteSpace: 'nowrap',
    right: 0,
}));

export const StyledListItem = styled.li(({ theme }) => ({
    padding: `0 ${theme.spaces[2]}`,
    ['&:hover']: {
        backgroundColor: theme.colors.light30,
    },
}));

export const StyledSortOption = styled(StyledResetButton)<{ isSelected: boolean }>(
    ({ theme, isSelected }) => ({
        fontFamily: theme.fonts.body,
        fontSize: theme.fontSizes.sm,
        fontWeight: isSelected ? theme.fontWeights.medium : theme.fontWeights.regular,
        minHeight: theme.spaces[5],
    })
);

export const StyledDrawerContainer = styled.div(({ theme }) => ({
    position: 'fixed',
    zIndex: theme.zIndices[3],
    [breakpoints.md]: {
        display: 'none',
    },
}));

export const StyledDrawerOverlay = styled.div<{ isOpen: boolean }>(({ theme, isOpen }) => ({
    ...cover,
    position: 'fixed',
    backgroundColor: theme.colors.light50,
    pointerEvents: isOpen ? 'auto' : 'none',
    opacity: isOpen ? theme.opacity.overlay : 0,
    transitionProperty: 'opacity',
    transitionDuration: theme.animations.getDuration('moderate01'),
    transitionTimingFunction: theme.animations.getEasing(
        isOpen ? 'entrance' : 'exit',
        'expressive'
    ),
}));

export const StyledDrawerContent = styled.div<{ isOpen: boolean }>(({ theme, isOpen }) => ({
    width: '100%',
    position: 'fixed',
    right: 0,
    backgroundColor: theme.colors.light,
    maxHeight: '100vh',
    bottom: 0,
    transform: isOpen ? 'translateY(0)' : 'translateY(100%)',
    zIndex: theme.zIndices[4],
    borderTop: `1px solid ${theme.colors.dark}`,
    transitionProperty: 'transform',
    transitionDuration: theme.animations.getDuration('moderate01'),
    transitionTimingFunction: theme.animations.getEasing(
        isOpen ? 'entrance' : 'exit',
        'expressive'
    ),
    [breakpoints.md]: {
        display: 'none',
    },
}));

export const StyledDrawerHeader = styled.div(({ theme }) => ({
    width: '100%',
    height: theme.spaces[7],
    borderBottom: theme.borders.border,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `0 ${theme.spaces[4]}`,
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.medium,
}));

export const StyledCloseButton = styled(StyledResetButton)<ButtonProps>(({ theme }) => ({
    fontSize: theme.fontSizes.xl,
}));

export const StyleContent = styled.div(({ theme }) => ({
    padding: '0',
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.md]: {
        maxHeight: `calc(100vh - ${theme.spaces[6]})`,
        overflowY: 'scroll',
    },
}));

export const StyledSortDrawerItem = styled(StyledResetButton)(({ theme }) => ({
    height: theme.spaces[7],
    borderBottom: `1px solid ${theme.colors.light50}`,
    display: 'flex',
    alignContent: 'center',
    padding: `0 ${theme.spaces[3]}`,
}));

export const StyledSortDrawerOption = styled.div<{ isSelected: boolean }>(
    ({ theme, isSelected }) => ({
        fontFamily: theme.fonts.body,
        fontSize: theme.fontSizes.md,
        fontWeight: isSelected ? theme.fontWeights.medium : theme.fontWeights.regular,
    })
);
